import React from "react";
import { ToastContainer, Slide } from "react-toastify";

const TOASTS_POSITION = "bottom-left";
const TOASTS_TIMEOUT = 5 * 1000; // 5 Секунд

const ToastContainerElement = () => {
  return (
    <ToastContainer
      className="toast-container"
      position={TOASTS_POSITION}
      autoClose={TOASTS_TIMEOUT}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick={true}
      rtl={false}
      pauseOnVisibilityChange={true}
      draggable={true}
      pauseOnHover={true}
      transition={Slide}
    />
  );
};

export default ToastContainerElement;
